<template>
  <modal :id="id" :show-footer="false" :isLoading="isLoading">
    <h3 class="mb-5 mt-5" slot="title">Share - {{ versionName }}</h3>
    <div slot="body" class="row" v-show="!isLoading">
      <div class="col-md-12">
        <h4><strong>Version Sharing</strong></h4>
        <p>
          The link below will provide colleagues a demo experience for your Inbox. This demo focuses
          on the Inbox itself and excludes onboarding, the scenario, and post-Inbox scoring.
        </p>
        <div class="form-group">
          <label for="demo-link">Share demo link:</label>
          <div class="input-group">
            <input
              id="demo-link"
              ref="demoLink"
              v-model="demoLink"
              type="text"
              class="form-control"
              readonly="readonly"
            />
            <span class="input-group-btn">
              <button class="btn" type="button" @click="onCopy">
                <span class="fas fa-copy" aria-hidden="true"> </span>
                {{ linkCopied ? 'Link Copied' : 'Copy Link' }}
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import { getDemoLink } from '@authoringPlatform/../api/versions';
  export default {
    props: {
      id: {
        type: String,
      },
      versionName: {
        type: String,
      },
      versionKey: {
        type: Number,
      },
    },

    data() {
      return {
        demoLink: '',
        isLoading: true,
        linkCopied: false,
      };
    },

    watch: {
      async versionKey(currKey, prevKey) {
        if (currKey && currKey !== prevKey) {
          this.isLoading = true;
          const { demoLink } = await getDemoLink(this.versionKey);
          this.demoLink = demoLink;
          this.isLoading = false;
        }
      },
    },

    methods: {
      onCopy() {
        this.$refs.demoLink.select();
        this.linkCopied = document.execCommand('copy');
        setTimeout(() => (this.linkCopied = false), 5000);
      },
    },
  };
</script>

<style scoped>
  #demo-link {
    background-color: white !important;
  }
</style>
